import { Controller } from "@hotwired/stimulus"

// Fills the search box with a filter prefix such as "driver: " and leaves the
// cursor after it, ready for the value.
export default class extends Controller {
  static targets = ["input"]

  insert({ params: { prefix } }) {
    this.inputTarget.value = `${prefix} `
    this.inputTarget.focus()
  }
}
